import React from 'react';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Lock, Zap, Globe2 } from 'lucide-react';
interface PurchaseSectionProps {
  id?: string;
}
export function PurchaseSection({
  id
}: PurchaseSectionProps) {
  return <section id={id} className="scroll-mt-10" data-id="element-199">
      {/* Red urgency countdown strip */}
      <div className="bg-red-950/50 py-4 px-4 text-center border-y border-red-700/40" data-id="element-200">
        <p className="text-red-300 font-black text-sm md:text-base tracking-widest mb-2 animate-pulse uppercase" data-id="element-201">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </p>
        <CountdownTimer className="!text-red-100 [&_div]:!border-red-700/40 [&_div]:!bg-red-950/70 [&_span]:!text-red-400/70 !text-2xl md:!text-4xl mb-1" data-id="element-202" />
        <p className="text-red-300/80 font-black text-[10px] md:text-xs uppercase tracking-widest mt-2" data-id="element-203">
          Después sube el precio y no vuelve a bajar.
        </p>
        <div className="max-w-md mx-auto mt-3" data-id="element-204">
          <div className="flex justify-between text-[10px] md:text-xs font-black mb-1 uppercase" data-id="element-205">
            <span className="flex items-center text-red-200" data-id="element-206">
              <span className="w-2 h-2 rounded-full bg-red-400 mr-1.5 animate-ping" data-id="element-207"></span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-red-300/80" data-id="element-208">Quedan pocos</span>
          </div>
          <div className="w-full bg-red-950/80 rounded-full h-2 overflow-hidden border border-red-700/30" data-id="element-209">
            <div className="bg-red-400 h-2 rounded-full w-[78%]" data-id="element-210"></div>
          </div>
          <p className="text-[9px] md:text-[10px] text-red-300/70 font-bold mt-1 text-right uppercase" data-id="element-211">
            78% de los cupos tomados
          </p>
        </div>
      </div>

      {/* Pricing section */}
      <div className="py-6 md:py-8 px-4 bg-brand-cardAlt" data-id="element-212">
        <div className="max-w-2xl mx-auto" data-id="element-213">
          <div className="text-center mb-5" data-id="element-214">
            <h2 className="text-xl md:text-3xl font-black text-white tracking-tight leading-none uppercase" data-id="element-215">
              Elige tu Kit:
            </h2>
          </div>

          <div className="bg-brand-card rounded-xl border-4 border-brand-accent p-5 md:p-8 flex flex-col relative shadow-[0_0_40px_rgba(34,197,94,0.3)] transform hover:scale-[1.02] transition-transform duration-300" data-id="element-216">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-brand-accent text-brand-dark font-black px-6 py-1.5 rounded-full text-xs md:text-sm tracking-widest shadow-lg whitespace-nowrap uppercase" data-id="element-217">
              🏆 OFERTA ÚNICA
            </div>

            <h3 className="text-lg md:text-2xl font-black text-white mb-2 mt-2 leading-tight text-center uppercase" data-id="element-218">
              KIT COMPLETO EDUCACIÓN FINANCIERA LISTA
            </h3>

            <p className="text-brand-accent font-bold text-sm md:text-base mb-4 text-center" data-id="element-219">
              Los 6 tomos + 4 bonos estratégicos + Actualizaciones de por vida
            </p>

            <div className="flex flex-col items-center justify-center mb-5 bg-brand-dark/50 py-4 rounded-lg border border-white/5" data-id="element-220">
              <span className="text-sm text-gray-500 line-through font-black mb-1" data-id="element-221">
                USD 45,00
              </span>
              <div className="flex items-baseline gap-2" data-id="element-222">
                <span className="text-sm font-bold text-gray-300" data-id="element-223">Hoy:</span>
                <span className="text-4xl md:text-5xl font-black text-brand-accent neon-glow" data-id="element-224">
                  USD 19,90
                </span>
              </div>
            </div>

            {/* Local currency callout — highlighted */}
            <div className="bg-gradient-to-br from-emerald-950/80 to-brand-dark border-2 border-brand-accent/60 rounded-lg p-4 mb-5 shadow-[0_0_20px_rgba(34,197,94,0.2)]" data-id="element-225">
              <div className="flex items-start gap-3" data-id="element-226">
                <div className="bg-brand-accent text-brand-dark rounded-full p-2 shrink-0 shadow-[0_0_15px_rgba(34,197,94,0.5)]" data-id="element-227">
                  <Globe2 className="w-4 h-4 md:w-5 md:h-5" data-id="element-228" />
                </div>
                <div className="flex-grow text-left" data-id="element-229">
                  <p className="text-xs md:text-sm font-black text-brand-accent uppercase tracking-wider mb-1" data-id="element-230">
                    ✅ Pagas en tu moneda local
                  </p>
                  <p className="text-xs md:text-sm text-white font-bold leading-relaxed" data-id="element-231">
                    El cobro{' '}
                    <span className="text-brand-accent" data-id="element-232">
                      se adapta automáticamente
                    </span>{' '}
                    a la moneda de tu país: pesos argentinos, pesos mexicanos,
                    pesos colombianos, soles peruanos, pesos chilenos,
                    guaraníes, bolívares, quetzales, lempiras y más.
                  </p>
                  <p className="text-[10px] md:text-xs text-gray-400 font-bold mt-1.5 italic" data-id="element-233">
                    Sin conversiones manuales. Sin necesidad de tener dólares.
                  </p>
                </div>
              </div>
            </div>

            <Button href="https://a3dm10-h0.myshopify.com/cart/44614109200519:1" className="py-4 md:py-5 text-base md:text-xl shadow-[0_0_30px_rgba(34,197,94,0.6)] w-full" pulse={true} data-id="element-234">
              💳 → QUIERO EL KIT COMPLETO AHORA
            </Button>
          </div>

          <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-xs md:text-sm text-gray-300 font-black uppercase tracking-wide mt-6" data-id="element-235">
            <div className="flex items-center" data-id="element-236">
              <Lock className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-237" />
              <span data-id="element-238">Pago seguro</span>
            </div>
            <div className="flex items-center" data-id="element-239">
              <Zap className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-240" />
              <span data-id="element-241">Acceso en 5 min</span>
            </div>
            <div className="flex items-center" data-id="element-242">
              <ShieldCheck className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-243" />
              <span data-id="element-244">Garantía 7 días</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}